import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { fetchStart, fetchStop } from '../../../../redux/actions/common'
import { trim } from '../../../../_metronic/helpers'
import Alert from '../../../../_metronic/partials/alert'
import { parsePhoneNumberWithError } from 'libphonenumber-js/max'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { scrollToErros } from '../../loanApplication/steps/Step1Sub1'

const errorMsg = {
  required: 'Mobile number is required',
  amountRange: 'Amount range should be between 100,000 - 3,000,000',
  durationRange: 'Duration range should be between 3 - 36 months',
}

const Step1Sub1: FC<any> = ({ sendOTP, setMobile, id, name, mobile }) => {
  const dispatch = useDispatch()
  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  const initialValues = {
    applicantName: name ? name : '',
    mobileNumber: mobile ? mobile : '',
  }
  const agentCode = localStorage.getItem('agentCode')

  const validationSchema = Yup.object().shape({
    applicantName: Yup.string()
      .required('Applicant Name is required')
      .test('unique', 'Applicant Name must not contain numbers', (value: any) => {
        return !/\d/.test(value)
      }),
    mobileNumber: Yup.string()
      .required(errorMsg.required)
      .test('mobileValidation', 'Please enter valid Singapore number', (value: any) => {
        if (!value) return false
        // Use libphonenumber-js to validate phone number format
        const number = parsePhoneNumberWithError(value, 'SG')
        // Use libphonenumber-js to validate phone number format
        return (
          isValidPhoneNumber(value, 'SG') &&
          number.isValid() &&
          number.country === 'SG' &&
          number.country === 'SG'
        )
      }),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      try {
        const { mobileNumber } = trim(values)
        dispatch(fetchStart())
        setMobile(mobileNumber)

        if (loanApplication?.applicationCompleteStep !== 3) {
          await sendOTP({
            variables: {
              mobileNo: mobileNumber,
              isApplicantOrShareholder: true,
              isCoApplicantKYB: true,
              id: id,
            },
          })
        } else {
          dispatch(fetchStop())
          setSubmitting(false)
          setShowAlert(true)
          setAlertType('primary')
          setAlertMsg('Application KYB Already Completed')
        }
      } catch (error) {
        console.error('Error sending OTP:', error)
      } finally {
        dispatch(fetchStop())
        setSubmitting(false)
      }
    },
  })

  let title = 'Company / Business eKYC'
  let subTitle =
    'You have been marked as an authorized person for your company. Please complete your business eKYC via Myinfo Business.'
  let formTitle = 'Applicant Details'

  if (agentCode) {
    title = 'Business eKYC'
    subTitle =
      'You have been marked as a Key decision maker for this loan application. Kindly proceed by completing your business eKYC using Myinfo business'
    formTitle = 'Enter following information to complete the verification'
  }

  return (
    <div className='d-flex flex-column '>
      <div className='notice d-flex banner text-start p-6 mb-5'>
        <div className='d-flex flex-stack flex-grow-1'>
          <div>
            <h2> {title} </h2>
            <div className='fs-3'>{subTitle}</div>
          </div>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='cardNew'>
          <div className='section-heading'>
            <h2>{formTitle}</h2>
            <hr className='text-gray-400' />
          </div>

          <div className='row'>
            <div className='col-md-6 mb-4'>
              <label htmlFor='' className='input-field-label required'>
                Applicant Name
              </label>
              <div className='col-sm-12'>
                <input
                  name='applicantName'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.applicantName}
                  onChange={formik.handleChange}
                />
                {formik.touched.applicantName && formik.errors.applicantName && (
                  <div className='text-danger mt-2'>{formik.errors.applicantName}</div>
                )}
              </div>
            </div>

            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Mobile Number
              </label>
              <div className='col-sm-12'>
                <PhoneInput
                  id='mobileNumber'
                  international
                  defaultCountry='SG'
                  // countryCallingCodeEditable={false}
                  value={formik.values.mobileNumber}
                  onChange={(value) => formik.setFieldValue('mobileNumber', value)}
                  placeholder='Enter phone number'
                  className='int-phone-input'
                />
                {(formik.touched.mobileNumber || formik.values.mobileNumber === undefined) &&
                  formik.errors.mobileNumber && (
                    <div className='text-danger mt-2'>{formik.errors.mobileNumber}</div>
                  )}
              </div>
            </div>
          </div>
        </div>

        <div className='cardNew stickeyFooter'>
          <div className='d-flex flex-end'>
            <button
              type='submit'
              id={agentCode ? 'button-primary' : ''}
              className='button button-primary'
              disabled={formik.isSubmitting}
              onClick={() => {
                scrollToErros()
              }}
            >
              {formik.isSubmitting ? 'Sending...' : 'Send OTP'}{' '}
              {agentCode !== null && (
                <svg
                  width='18'
                  height='18'
                  viewBox='0 0 18 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g clip-path='url(#clip0_11424_19811)'>
                    <path
                      d='M3.75 9H14.25'
                      stroke='white'
                      stroke-width='1.5'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M11.25 12L14.25 9'
                      stroke='white'
                      stroke-width='1.5'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M11.25 6L14.25 9'
                      stroke='white'
                      stroke-width='1.5'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_11424_19811'>
                      <rect width='18' height='18' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              )}
            </button>
          </div>
        </div>
      </form>

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </div>
  )
}

export { Step1Sub1 }
